// extracted by mini-css-extract-plugin
module.exports = {"image":"BlogPost__image___Z4bP-"};